export default __webpack_public_path__ + "static/media/RC5_Allston_PhotobyAramBoghosian_5.701a1301.jpg";